import Phaser from 'phaser';

export default class Confetti{

    constructor(){
        this.scene = GAME_REF.scene;
        this._init();
    }


    update() {
        const skew = [0.02, 0.04, 0.06, 0.08, 0.1],
            xPlus = [0.5, 0.75, 1, 1.2, 1.5];

        for (let i = 0; i < this.createNum; i++) {
            let x, y, colornum = i % this.color.length;

            this.graphics[i].clear();
            this.graphics[i].fillStyle(this.color[colornum], 1).fillRect(-5, -5, 10, 20);

            if (this.graphics[i].y > this.ch) {
                x = Phaser.Math.Between(10, this.cw);
                y = -10;
            } else {
                y = this.graphics[i].y + 4 + ((i % 5) * 0.1);
            }

            if (this.graphics[i].x > this.cw - 10) {
                this.xAdd[i] = -1;
            } else if (this.graphics[i].x < 10) {
                this.xAdd[i] = 1;
            }

            if (this.xAdd[i] === -1) {
                x = this.graphics[i].x - xPlus[i % 5];
            } else {
                x = this.graphics[i].x + xPlus[i % 5];
            }

            this.graphics[i].scaleX = this.scale[i];
            this.graphics[i].scaleY = this.scale[i];
            this.graphics[i].x = x;
            this.graphics[i].y = y;
            this.graphics[i].rotation += i % 2 === 0 ? (0.01 + ((i % 5) * 0.01)) : (0.01 + ((i % 5) * -0.01));
        }
    }

    _init(){
        this.cw = 1280;
        this.ch = 800;
        this.createNum = 40;
        this.color = [0xffffff, 0xff2a5c, 0xe4ff2a, 0xa62aff, 0x3df2da, 0xff2a9c, 0x2aff9f];
        this.xAdd = [];
        this.graphics = [];
        this.scale = [];
        this._create();
    }


    _create(){
        
        for (let i = 0; i < this.createNum; i++) {
            const colornum = i % this.color.length;
            const x = Phaser.Math.Between(10, this.cw);
            const y = Phaser.Math.Between(0, this.ch);

            this.scale.push(((Phaser.Math.Between(8, 12)) / 10));
            this.xAdd.push(i % 2 === 0 ? 1 : -1);
            
            const gra = this.scene.add.graphics({x, y});
            gra.fillStyle(this.color[colornum], 1);
            gra.fillRect(-5, -5, 10, 20);
            gra.x = x;
            gra.y = y;
            gra.setScale(this.scale[i]);
            gra.angle = 0.1 + ((i % 5) * 0.1);
            this.graphics.push(gra);
        }
    }
}